import React, { useState } from 'react';
import { Table, Select, Card, Row, Col, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faBook, faClock, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import '../../css/JuanIS/JuanISFacultyClassInformation.css';

const { Option } = Select;
const { Title } = Typography;

function JuanISFacultyClassInformation() {
  const [selectedClass, setSelectedClass] = useState('STEM-11A-OralComm');

  // Sample data - replace with actual data from your backend
  const classes = [
    { value: 'STEM-11A-OralComm', label: 'STEM-11A - Oral Communication' },
    { value: 'STEM-11B-GenMath', label: 'STEM-11B - General Mathematics' }
  ];

  const studentData = [
    {
      key: '1',
      studentId: '2024-0001',
      name: 'Juan Dela Cruz',
      attendance: '95%',
      status: 'Regular'
    },
    {
      key: '2',
      studentId: '2024-0002',
      name: 'Maria Santos',
      attendance: '92%',
      status: 'Regular'
    }
  ];

  const columns = [
    {
      title: 'Student ID',
      dataIndex: 'studentId',
      key: 'studentId',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Attendance',
      dataIndex: 'attendance',
      key: 'attendance',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    }
  ];

  const classStats = [
    {
      icon: faUsers,
      title: 'Total Students',
      value: '35',
      color: '#4a90e2'
    },
    {
      icon: faBook,
      title: 'Subject Code',
      value: 'CORSBJ1',
      color: '#FFB800'
    },
    {
      icon: faClock,
      title: 'Schedule',
      value: 'MWF 8:00-9:00 AM',
      color: '#50c878'
    },
    {
      icon: faChalkboardTeacher,
      title: 'Room',
      value: 'Room 101',
      color: '#ff6b6b'
    }
  ];

  return (
    <div className="juanis-faculty-class-info-container">
      <div className="juanis-faculty-class-info-header">
        <Title level={2}>Class Information</Title>
        <Select
          value={selectedClass}
          onChange={setSelectedClass}
          className="juanis-faculty-class-info-select"
        >
          {classes.map(cls => (
            <Option key={cls.value} value={cls.value}>{cls.label}</Option>
          ))}
        </Select>
      </div>

      <Row gutter={[16, 16]} className="juanis-faculty-class-info-stats-row">
        {classStats.map((stat, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card className="juanis-faculty-class-info-stat-card">
              <div className="juanis-faculty-class-info-stat-icon" style={{ color: stat.color }}>
                <FontAwesomeIcon icon={stat.icon} />
              </div>
              <div className="juanis-faculty-class-info-stat-info">
                <h3>{stat.title}</h3>
                <p>{stat.value}</p>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="juanis-faculty-class-info-student-list-section">
        <Title level={3}>Student List</Title>
        <Table 
          dataSource={studentData} 
          columns={columns}
          className="juanis-faculty-class-info-student-table"
          scroll={{ x: 600 }} // Enable horizontal scrolling for smaller screens
        />
      </div>
    </div>
  );
}

export default JuanISFacultyClassInformation;